import type { JobTag } from '@seek/chalice-types';

export const mapJobTagsType = (jobTags?: JobTag[]) =>
  jobTags?.map((j) => j.type) ?? [];
